import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { alertsGroupClass } from './styles';

import { showAlertActionCreator } from '../../store';
import { AlertItem, type AlertItemProps, AlertTypes } from '../AlertItem';

export interface AlertsGroupProps {
  alertsData: AlertItemProps[];
  onCloseAlert: (id: string) => void;
}

export const AlertsGroup: React.FC<AlertsGroupProps> = React.memo(
  ({ alertsData, onCloseAlert }: any) => {
    const dispatch = useDispatch();

    useEffect(() => {
      document.addEventListener('alert/create', (event: any) => {
        const { type, message, alertConfig } = event.detail;

        dispatch(showAlertActionCreator(type, message, alertConfig));
      });

      return document.removeEventListener('alert/create', () => {});
    }, []);

    const priorityAlert = (type: AlertTypes) => {
      if (type === AlertTypes.INFO) {
        return 1;
      }

      return Number.POSITIVE_INFINITY;
    };

    return (
      <div className={alertsGroupClass}>
        {[...alertsData]
          .sort(
            (a, b) => priorityAlert(a.alertType) - priorityAlert(b.alertType)
          )
          .map((data) => {
            return (
              <AlertItem {...data} onCloseAlert={onCloseAlert} key={data.id} />
            );
          })}
      </div>
    );
  }
);
